<div class="detail-container">
  <!-- Header -->
  <div class="detail-header">
    <div class="header-content">
      <div class="header-left">
        <span class="header-icon"><i class="fa-solid fa-chart-line"></i></span>
        <div class="header-text">
          <h1>Métricas de Omnicanal</h1>
          <p class="header-subtitle">Captación, origen y conversión de tus prospectos y clientes.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div class="metrics-state" *ngIf="loading">
    <p-progressSpinner [style]="{ width: '42px', height: '42px' }" strokeWidth="4" ariaLabel="Cargando métricas"></p-progressSpinner>
    <span>Cargando métricas…</span>
  </div>

  <!-- Error -->
  <div class="metrics-state error" *ngIf="!loading && loadError">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>No se pudieron cargar las métricas. Recarga la página e inténtalo de nuevo.</span>
  </div>

  <ng-container *ngIf="!loading && !loadError">
    <!-- KPIs -->
    <div class="kpi-grid">
      <div class="kpi-card" *ngFor="let k of kpiCards" [ngClass]="'accent-' + k.accent">
        <span class="kpi-icon"><i [class]="k.icon"></i></span>
        <div class="kpi-body">
          <span class="kpi-val">{{ k.value }}</span>
          <span class="kpi-lbl">{{ k.label }}</span>
        </div>
      </div>
    </div>

    <!-- Charts -->
    <div class="charts-grid">
      <!-- Origen de captación -->
      <div class="metric-card">
        <div class="metric-head">
          <span class="metric-icon accent-indigo"><i class="fa-solid fa-diagram-project"></i></span>
          <div class="metric-head-text">
            <h3>Origen de captación</h3>
            <p class="metric-desc">Cómo llegó cada cliente: solo por el canal digital, por un link de referido, o registrado por un broker o el equipo.</p>
          </div>
        </div>
        <div class="metric-body">
          <ul class="hbar-list acq-list" *ngIf="hasAcquisition; else emptyAcq">
            <li *ngFor="let a of acquisition">
              <div class="hbar-row">
                <span class="hbar-name">{{ a.label }}</span>
                <span class="hbar-meta"><strong>{{ a.count }}</strong> · {{ acqPct(a.count) }}%</span>
              </div>
              <div class="hbar-track"><div class="hbar-fill" [style.width.%]="(a.count / acqMax) * 100" [style.background]="a.fill" [style.border]="'1px solid ' + a.color"></div></div>
            </li>
          </ul>
          <ng-template #emptyAcq>
            <div class="empty-chart"><i class="fa-solid fa-diagram-project"></i><span>Aún no hay clientes registrados. Cuando entren, verás por dónde llegaron.</span></div>
          </ng-template>
        </div>
      </div>

      <!-- Embudo de conversión -->
      <div class="metric-card">
        <div class="metric-head">
          <span class="metric-icon accent-green"><i class="fa-solid fa-filter"></i></span>
          <div class="metric-head-text">
            <h3>Embudo de conversión</h3>
            <p class="metric-desc">En qué etapa del funnel está cada prospecto/cliente: en funnel, en originación, ganado o perdido.</p>
          </div>
        </div>
        <div class="metric-body">
          <div class="chart-box" *ngIf="hasConversion; else emptyConv">
            <p-chart type="polarArea" [data]="conversionData" [options]="conversionOptions" [style.height]="conversionHeight"></p-chart>
          </div>
          <ng-template #emptyConv>
            <div class="empty-chart"><i class="fa-solid fa-filter"></i><span>Aún no hay prospectos ni clientes en el funnel.</span></div>
          </ng-template>
        </div>
      </div>

      <!-- Prospectos nuevos por mes -->
      <div class="metric-card">
        <div class="metric-head">
          <span class="metric-icon accent-blue"><i class="fa-solid fa-calendar-day"></i></span>
          <div class="metric-head-text">
            <h3>Prospectos nuevos por mes</h3>
            <p class="metric-desc">Cuántos prospectos nuevos entraron cada mes (últimos 12 meses). Útil para ver la tendencia de captación.</p>
          </div>
        </div>
        <div class="metric-body">
          <div class="trend-chart" *ngIf="hasArrivals; else emptyArrivals">
            <div class="trend-cols">
              <div class="trend-col" *ngFor="let mth of arrivalsMonths">
                <span class="trend-val" *ngIf="mth.count > 0">{{ mth.count }}</span>
                <div class="trend-bar" [class.zero]="mth.count === 0" [style.height.%]="(mth.count / arrivalsMax) * 100"></div>
              </div>
            </div>
            <div class="trend-labels">
              <span *ngFor="let mth of arrivalsMonths">{{ mth.label }}</span>
            </div>
          </div>
          <ng-template #emptyArrivals>
            <div class="empty-chart"><i class="fa-solid fa-chart-line"></i><span>Aún no hay prospectos nuevos registrados.</span></div>
          </ng-template>
        </div>
      </div>

      <!-- Top referidores -->
      <div class="metric-card">
        <div class="metric-head">
          <span class="metric-icon accent-indigo"><i class="fa-solid fa-user-plus"></i></span>
          <div class="metric-head-text">
            <h3>Top referidores</h3>
            <p class="metric-desc">Qué vendedores o brokers traen más clientes por su link de referido (top 5).</p>
          </div>
        </div>
        <div class="metric-body">
          <ul class="hbar-list acq-list" *ngIf="hasReferrers; else emptyReferrers">
            <li *ngFor="let r of topReferrers; let i = index">
              <div class="hbar-row">
                <span class="hbar-name"><span class="rank-badge" [class.top]="i === 0">{{ i + 1 }}</span>{{ r.name }}</span>
                <span class="hbar-meta"><strong>{{ r.count }}</strong> {{ r.count === 1 ? 'referido' : 'referidos' }}</span>
              </div>
              <div class="hbar-track"><div class="hbar-fill" [style.width.%]="(r.count / refMax) * 100" [style.background]="'rgba(99,102,241,0.75)'" [style.border]="'1px solid #6366f1'"></div></div>
            </li>
          </ul>
          <ng-template #emptyReferrers>
            <div class="empty-chart"><i class="fa-solid fa-user-plus"></i><span>Aún no hay clientes referidos. Cuando alguien llegue por un link de referido, aparecerá aquí.</span></div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- ══════ Desempeño por vendedor ══════ -->
    <div class="seller-perf">
      <div class="charts-grid">
        <div class="metric-card">
          <div class="metric-head">
            <span class="metric-icon accent-amber"><i class="fa-solid fa-user-clock"></i></span>
            <div class="metric-head-text">
              <h3>Prospectos por vendedor</h3>
              <p class="metric-desc">Barra = prospectos; a la derecha, conteo y valor cotizado.</p>
            </div>
          </div>
          <div class="metric-body">
            <ul class="hbar-list" *ngIf="hasSellerProspects; else emptySP">
              <li *ngFor="let r of sellerProspects" class="clickable" role="button" (click)="openProspectDetail(r.sellerId)">
                <div class="hbar-row">
                  <span class="hbar-name">{{ r.name }}</span>
                  <span class="hbar-meta"><strong>{{ r.prospectos }}</strong> prospectos · {{ fmtCompact(r.quotedValue) }} cotizados</span>
                </div>
                <div class="hbar-track"><div class="hbar-fill amber" [style.width.%]="(r.prospectos / spMax) * 100"></div></div>
              </li>
            </ul>
          </div>
        </div>
        <div class="metric-card">
          <div class="metric-head">
            <span class="metric-icon accent-green"><i class="fa-solid fa-user-check"></i></span>
            <div class="metric-head-text">
              <h3>Clientes por vendedor</h3>
              <p class="metric-desc">Barra = clientes ganados; a la derecha, clientes y arrendamientos.</p>
            </div>
          </div>
          <div class="metric-body">
            <ul class="hbar-list" *ngIf="hasSellerClients; else emptySC">
              <li *ngFor="let r of sellerClients">
                <div class="hbar-row">
                  <span class="hbar-name">{{ r.name }}</span>
                  <span class="hbar-meta"><strong>{{ r.clientes }}</strong> clientes · {{ r.leases }} arrendamientos</span>
                </div>
                <div class="hbar-track"><div class="hbar-fill green" [style.width.%]="(r.clientes / scMax) * 100"></div></div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Empty states contextuales -->
      <ng-template #emptySP>
        <div class="empty-chart"><i class="fa-solid fa-user-clock"></i><span>Aún no hay vendedores internos con prospectos asignados.</span></div>
      </ng-template>
      <ng-template #emptySC>
        <div class="empty-chart"><i class="fa-solid fa-user-check"></i><span>Aún no hay vendedores internos con clientes ganados.</span></div>
      </ng-template>
    </div>

    <!-- Modal: detalle de prospectos por vendedor (tab por vendedor) -->
    <p-dialog [(visible)]="detailVisible" [modal]="true" [closable]="true" [draggable]="false" [dismissableMask]="true" header="Detalle de prospectos por vendedor" styleClass="prospect-detail-dialog" [style]="{ width: '760px', maxWidth: '95vw' }">
      <p-tabView [(activeIndex)]="detailActiveIndex" *ngIf="detailVisible">
        <p-tabPanel *ngFor="let s of sellerProspects" [header]="s.name">
          <table class="pd-table" *ngIf="detailItems(s.sellerId).length; else emptyPD">
            <thead><tr><th>Cliente</th><th>Activo</th><th class="num">Valor total</th></tr></thead>
            <tbody>
              <tr *ngFor="let it of detailItems(s.sellerId)">
                <td class="name">{{ it.client }}</td>
                <td>{{ it.asset }}</td>
                <td class="num money">{{ fmtMoney(it.total) }}</td>
              </tr>
            </tbody>
          </table>
          <ng-template #emptyPD>
            <div class="pd-empty">Este vendedor no tiene propuestas registradas.</div>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </p-dialog>
  </ng-container>
</div>
